import { createActivitySubcoverage } from './api';

/**
 * Service de création d'une sous-couverture activité.
 * Encapsule l'appel POST /subcoverage/{reference_id}.
 */
export async function createSubCoverage(referenceId, payload) {
    if (!referenceId) {
        throw new Error('reference_id manquant pour la création de la sous-couverture');
    }
    return createActivitySubcoverage(referenceId, payload);
}
